export const getAllFilters = payload => ({
  type: 'GET_ALL_FILTER',
  payload,
});

export const setAllFilters = payload => ({
  type: 'SET_ALL_FILTER',
  payload,
});

export const getFieldType = payload => ({
  type: 'GET_FIELD_TYPE',
  payload,
});

export const getFieldDropDownData = payload => ({
  type: 'GET_FIELD_DD_DATA',
  payload,
});

export const setFieldDropDownData = payload => ({
  type: 'SET_FIELD_DD_DATA',
  payload,
});

export const clearFields = payload => ({
  type: 'CLEAR_FIELDS',
  payload,
});

export const getAllSaveFilters = payload => ({
  type: 'GET_SAVE_FILTER',
  payload,
});

export const setSaveFilter = payload => ({
  type: 'SET_SAVE_FILTER',
  payload,
});

export const applyQueryFilter = payload => ({
  type: 'SEARCH_QUERY',
  payload,
  loader: true,
});

export const setWalletConTypeFilterData = payload => ({
  type: 'ALL_USER_LIST',
  data: payload,
});

export const setExpenseConTypeFilterData = payload => ({
  type: 'SET_EXPENSE',
  data: payload,
});

export const applySaveFilter = payload => ({
  type: 'SAVE_FILTER',
  payload,
  loader: true,
});

export const clearChoices = payload => ({
  type: 'CLEAR_CHOICES',
  data: payload,
});

export const resetQuery = payload => ({
  type: 'SET_QUERY',
  payload,
});

export const SelectedSaveFilter = payload => ({
  type: 'SET_SELECTED_SAVE_FILTER',
  payload,
});

export const storeAppliedFilter = appliedFilter => ({
  type: 'APPLIED_FILTERS',
  appliedFilter,
});

export const downloadEtl = (payload, url) => ({
  type: 'DOWNLOAD_ETL',
  payload,
  loader: true,
  url
});

export const showSnackbar = data => ({
  type: 'SHOW_SNACK_BAR',
  data,
});